import {useQuery} from "react-query";
import userTaskService from "../../services/UserTaskService";
import {UserTaskSearchRequest} from "../../models/user-task";

export default function useUserTasks(request?: UserTaskSearchRequest) {
   return useQuery(['user-tasks', request], () => userTaskService.search(request), {
      refetchInterval: 30_000
   });
}